import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const linksMap = {
  'tuxedo-pocket-square': (
    <Link href="/collection/accessories/dusty-rose-pocket-square" className="tracker-text-accessories_rose_pocket_square-230525-133329">
      {'tuxedo pocket square'}
    </Link>
  ),
  'suit-cufflink': (
    <Link
      href="/collection/accessories/black-and-silver-cufflinks-and-studs"
      className="tracker-text-accessories_black_silver_cufflinks-230525-133330"
    >
      {'suit cufflink'}
    </Link>
  ),
  'suit-belt': (
    <Link href="/collection/accessories/brown-belt-with-silver-buckle" className="tracker-text-accessories_brown_belt-230525-133331">
      {'suit belt'}
    </Link>
  ),
  'tux-suspenders': (
    <Link href="/collection/accessories/black-suspenders" className="tracker-text-accessories_black_suspenders-230525-133332">
      {'tux suspenders'}
    </Link>
  ),

  'traditional-black': (
    <Link href="/collection/accessories/black-pocket-square" className="tracker-text-accessories_black_pocket_square-230525-133333">
      {'traditional black'}
    </Link>
  ),
  white: (
    <Link href="/collection/accessories/white-pocket-square" className="tracker-text-accessories_white_pocket_square-230525-133334">
      {'white'}
    </Link>
  ),
  rose: (
    <Link href="/collection/accessories/pewter-rose-lapel-pin" className="tracker-text-accessories_rose_label_pins-230525-133335">
      {'rose'}
    </Link>
  ),
  'carnation-shaped-pins': (
    <Link href="/collection/accessories/coral-reef-carnation-lapel-pin" className="tracker-text-accessories_coral_lapel_pins-230525-133336">
      {'carnation shaped pins'}
    </Link>
  ),
};

const AccessoriesCopy = () => (
  <Layout1x1>
    <h3 data-testid="accs-title" className="text-h2">
      {'Every Accessory to Suit Your Need'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="accs-desc" className="!mb-64 text-gray-darker">
      No matter the suit accessories you’re looking for, we’ve got the pieces to complete your look. Whether you’re looking for the perfect
      accent — like a {linksMap['tuxedo-pocket-square']} and {linksMap['suit-cufflink']} — or if you just need to hold yourself together
      with a {linksMap['suit-belt']} or {linksMap['tux-suspenders']}, we’ve got you covered.
    </p>

    <h3 data-testid="accs-title" className="text-h2">
      {'Pocket Square Colors'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="accs-desc" className="!mb-64 text-gray-darker">
      Pocket squares may seem like a trifle detail, but the perfect accent can make your whole look pop. From{' '}
      {linksMap['traditional-black']} and {linksMap.white} to nearly every shade in between, Menguin has the perfect color to suit your
      suit’s needs.
    </p>

    <h3 data-testid="accs-title" className="text-h2">
      {'Lapel Pins'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="accs-desc" className="!mb-64 text-gray-darker">
      Searching for the standout men’s suit accessory? Suit lapel pins are a stylish way to make a statement, and we have tons of colors to
      choose from. These {linksMap.rose} and {linksMap['carnation-shaped-pins']} are unique and elegant suit or tuxedo accessories that are
      sure to impress.
    </p>

    <h3 data-testid="accs-title" className="text-h2">
      {'Suit Belts and Suspenders'}
    </h3>
    <Line className="!text-gray-dark" />
    <p data-testid="accs-desc" className="text-gray-darker">
      {
        'For any suit or tux, suspenders or a belt are a must-have. Find the perfect suit suspenders and tux belts to make sure your fit looks and stays perfect.'
      }
    </p>
  </Layout1x1>
);

export default AccessoriesCopy;
